import router from '@/router'

const catchUnauthorizedError = (): void => {
  localStorage.removeItem('token')
  router.push({ name: 'login' })
}

export default catchUnauthorizedError
